import React from 'react';

const FAQ = () => {
    return (
        <div className='mt-5'>
            <h2 className='text-center'>No FAQ for today</h2>
        </div>
    );
};

export default FAQ;